module.exports = __webpack_public_path__ + "static/media/tanque-gris_old.67fcdb62.svg";